import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { useSelector } from "react-redux";
import { designColors, designType } from "services/constants/designTokens";
import { dashboard } from "./dashboardStyles";

// Time-of-day greeting used at the top of the Home dashboard.
const greetingForHour = (hour) => {
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

export const HomeGreeting = () => {
  const { userDetails } = useSelector((state) => state.tokenReducer);
  const now = new Date();
  const firstName = userDetails?.first_name || "there";
  const dateLabel = now.toLocaleDateString(undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", sm: "center" }}
      spacing={2}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${designColors.tealTint} 0%, #F4FBF8 100%)`,
            color: designColors.tealDark,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <PersonRoundedIcon sx={{ fontSize: 32 }} />
        </Box>
        <Box>
          <Typography sx={designType.pageTitle}>
            {greetingForHour(now.getHours())}, {firstName}
          </Typography>
          <Typography sx={designType.pageSubtitle}>
            My Workspace Home keeps your schedule, requests, payslips, and actions in one place.
          </Typography>
        </Box>
      </Stack>
      <Typography
        variant="body2"
        sx={{ color: dashboard.colors.subText, fontWeight: 600 }}
      >
        {dateLabel}
      </Typography>
    </Stack>
  );
};
